export default __webpack_public_path__ + "static/media/Harness of Wild Furor.adcd7d4a.jpg";